export default {
  install: (app, options) => {
    app.config.globalProperties.$gotoMain = $gotoMain;
    app.config.globalProperties.$gotoShop = $gotoShop;
    app.config.globalProperties.$gotoCart = $gotoCart;
    app.config.globalProperties.$gotoSupplierContact = $gotoSupplierContact;
    app.config.globalProperties.$gotoShopBySupplierRefId = $gotoShopBySupplierRefId;
    app.config.globalProperties.$gotoCommonError = $gotoCommonError;
    app.config.globalProperties.$gotoIntro = $gotoIntro;
    app.config.globalProperties.$gotoInfoSite = $gotoInfoSite;
    app.provide('PageRouter', options);
  }
}

export function $gotoInfoSite(ins) {  
  if(ins){
    console.log("Redirecting to www site.");
  }
  window.location.href="https://www.solartronis.com";
}

export function $gotoIntro(ins) {  
  if(ins){
    console.log("Redirecting to www site.");
  }
  window.location.href="https://www.solartronis.com";
}

export function $gotoMain(ins) {  
  ins.$router.push({
    path: "/",
  });
}

export function $gotoShop(ins) {
  let supplierRefId = ins.$retrieveSupplierRefId();
  if (supplierRefId) {
    ins.$router.push({
      path: "/store/" + supplierRefId,
    });
  } else {
    ins.$router.push({
      path: "/",
    });
  }
}

export function $gotoCart(ins) {
  let supplierRefId = ins.$retrieveSupplierRefId();
  if (supplierRefId) {
    ins.$router.push({
      path: "/cart",
    });
  } else {
    ins.$router.push({
      path: "/",
    });
  }
}

export function $gotoSupplierContact(ins) {

  let supplierRefId = ins.$retrieveSupplierRefId();
  if (supplierRefId) {
    ins.$router.push({
      path: "/contact/" + supplierRefId,
    });
  } else {
    ins.$router.push({
      path: "/",
    });
  }

}


export function $gotoShopBySupplierRefId(supplierRefId) {
  if (supplierRefId) {
    this.$router.push({
      path: "/store/" + supplierRefId,
    });
  } else {
    this.$router.push({
      path: "/",
    });
  }
}

export function $gotoCommonError(ins) {
  ins.$router.push({ path: '/error' });
}